module.exports = __webpack_public_path__ + "static/media/formation.99c76c48.png";